import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { OLD_PRICE, PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/polski';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-222" data-mp="1mm7h2qfrd1c9">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-223" data-mp="1hpqqlpl36aw0">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-224" data-mp="tzwh9hzz74gi">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-225" data-mp="u0oaim63oq3m">
            Poznaj swój kompletny pakiet <em className="text-red-300" data-id="element-226" data-mp="13xkcsa5eofzq">POLSKI GOTOWY™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-227" data-mp="13uoh6sh163eg">
            Cały rok języka polskiego – gotowy. W klasie z planem w 5 minut.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-228" data-mp="2fad1td6taqc3" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-229" data-mp="pk7edh9xud7c">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-230" data-mp="ui0k697bx573">Kompletny pakiet zawiera</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-231" data-mp="zjg39vpy51mu">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-232" data-mp="13jgkfo4fjqxl">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-233" data-mp="6u9733dyso4r">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-234" data-mp="btvkbctsm4dk" />
                </span>
                <span data-id="element-235" data-mp="fsupmyjfs35j">
                  <span className="block font-medium leading-snug" data-id="element-236" data-mp="fskw50z6ndv3">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-237" data-mp="kmfdhxrbfgr0">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-238" data-mp="3o9fsdxlh6007">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-239" data-mp="vdnuyjol9t74">
              Cena wprowadzająca{' '}
              <span className="sr-only" data-id="element-240" data-mp="qetcxjyg48o2">– cena regularna: </span>
              <s className="ml-1 font-serif text-xl text-slate-900/50" data-id="element-241" data-mp="1550qbl9lj1hw">{OLD_PRICE}</s>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-242" data-mp="106z6gy4ciy5d">
              <span className="sr-only" data-id="element-243" data-mp="ch4vyn7i1loa">Cena teraz: </span>
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-244" data-mp="7jwcmjam7blg">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="lf87cqort22d" />
            Jednorazowa płatność. Bez subskrypcji.
          </p>

          <CtaButton label="Zamów cały pakiet teraz" className="mt-8 w-full" data-id="element-246" data-mp="1wvyh2jsekc0q" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-247" data-mp="1sveircw3f2d0">
            {offerIncludes.map(item => <li key={item} data-id="element-248" data-mp="20dm31xqr0e1c">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}